import { render } from "./WordsCard.vue?vue&type=template&id=f655201a&scoped=true&ts=true"
import script from "./WordsCard.vue?vue&type=script&lang=ts"
export * from "./WordsCard.vue?vue&type=script&lang=ts"

import exportComponent from "/root/workspace/lll-ui_hccl/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f655201a"]])

export default __exports__